import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getAllBlogs } from "../features/ads/adsSlice";
import { Autoplay } from "swiper/modules";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";

SwiperCore.use([Autoplay]);

const TopBannerSlider = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const blogState = useSelector((state) => state.blog);
  const blog = blogState?.blog || [];
  const isLoading = blogState?.isLoading;

  useEffect(() => {
    dispatch(getAllBlogs());
  }, [dispatch]);

  // Only show on home page
  if (location.pathname !== "/") return null;

  const filteredBlogs = blog
    .filter((item) => item.category === "new")
    .slice(0, 3);

  if (isLoading || filteredBlogs.length === 0) return null;

  return (
    <div className="w-full overflow-hidden bg-teal-950 relative border-b border-white/5">
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        className="h-[45px] md:h-[65px] w-full"
      >
        {filteredBlogs.map((item, index) =>
          item.images.map((image, imgIndex) => (
            <SwiperSlide key={`${index}-${imgIndex}`}>
              <Link
                to={`/${item.category}`}
                className="flex items-center justify-center w-full h-full relative group"
              >
                <img
                  src={image.secure_url}
                  alt="banner"
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-70 transition-opacity duration-700"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-r from-teal-950/40 via-transparent to-teal-950/40">
                  <div className="flex items-center gap-3 px-6 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 shadow-2xl transform transition-transform duration-500 group-hover:scale-105">
                    <span className="text-teal-300 animate-pulse">✨</span>
                    <span className="text-white text-[10px] md:text-[13px] font-black uppercase tracking-[0.2em] drop-shadow-lg">
                      {item.title || "Exclusive Health Offers"} - Click to
                      Explore
                    </span>
                    <span className="text-teal-300 animate-pulse">✨</span>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          )),
        )}
      </Swiper>
    </div>
  );
};

export default TopBannerSlider;
